import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Économisez {{percentageAmount}}% sur les articles sélectionnés',
    description:
      "Économisez {{percentageAmount}}% sur votre commande en commandant les articles sélectionnés. L'offre est valable{{fromTo}} jusqu'à ce que la limite maximale des promotions soit atteinte, selon la première éventualité. Non cumulable avec d'autres promotions.",
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% de réduction dès {{minSpendValue}}',
    description:
      "Économisez {{percentageAmount}}% sur votre commande. L'offre est valable{{fromTo}} jusqu'à ce que la limite maximale des promotions soit atteinte, selon la première éventualité. Non cumulable avec d'autres promotions.",
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Économisez {{amount}} sur les articles sélectionnés',
    description:
      "Économisez {{amount}} en commandant les articles sélectionnés. L'offre est valable{{fromTo}} jusqu'à ce que la limite maximale des promotions soit atteinte, selon la première éventualité. Non cumulable avec d'autres promotions.",
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Économisez {{amount}} dès {{minSpendValue}}',
    description:
      "Économisez {{amount}} sur une valeur de commande. L'offre est valable{{fromTo}} jusqu'à ce que la limite maximale des promotions soit atteinte, selon la première éventualité. Non cumulable avec d'autres promotions.",
  },
  [OfferKindEnum.Bogo]: {
    title: '2 achetés, 1 offert !',
    description:
      "Achetez un article et obtenez le deuxième gratuitement. L'offre est valable{{fromTo}} jusqu'à ce que la limite promotionnelle soit atteinte, selon la première éventualité. Non cumulable avec d'autres promotions.",
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: '1 acheté, le 2ème à moitié prix !',
    description:
      "Achetez un article et obtenez le deuxième à moitié prix. L'offre est valable{{fromTo}} jusqu'à ce que la limite promotionnelle soit atteinte, selon la première éventualité. Non cumulable avec d'autres promotions.",
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Article offert dès un certain montant de commande',
    description:
      "Recevez un article offert lorsque vous remplissez les conditions de l'offre. L'offre est valable{{fromTo}} jusqu'à ce que la limite promotionnelle soit atteinte, selon la première éventualité. Non cumulable avec d'autres promotions.",
    reward_items_description: 'Choisissez votre article offert.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Article offert avec votre commande',
    description:
      "Recevez un article offert lorsque vous remplissez les conditions de l'offre. L'offre est valable{{fromTo}} jusqu'à ce que la limite promotionnelle soit atteinte, selon la première éventualité. Non cumulable avec d'autres promotions.",
    qualifying_items_description:
      "Sélectionnez les articles que le client doit commander pour obtenir l'article offert.",
    reward_items_description: 'Choisissez votre article offert.',
  },
};

export default {
  offers,
  from_to: ' du {{startsAt}} au {{endsAt}} ou',
  qualifying_items_title: 'Articles éligibles',
  reward_items_title: 'Articles offerts',
  buttons: {
    add: 'Ajouter au panier',
  },
};
